import { Link, LinkProps } from 'react-router';
import { Tab, TabProps, Tabs as MuiTabs, useTheme, Box } from '@mui/material';

import { a11yProps } from '@shared/utils';

/* Use the same id as TabPanel */
interface Props<TOption extends string | number> {
  prefixId: string;
  tabs: Array<Pick<TabProps, 'label' | 'icon'> & Pick<LinkProps, 'to'> & { value: TOption }>;
  currentTab: TOption | null;
  linkState?: LinkProps['state'];
}

export default function Tabs<TOption extends string | number>({
  prefixId,
  tabs,
  currentTab,
  linkState,
}: Props<TOption>) {
  const { breakpoints } = useTheme();
  return (
    <Box
      sx={{
        [breakpoints.down('md')]: {
          maxWidth: 'calc(100dvw - 64px)',
        },
      }}
    >
      <MuiTabs value={currentTab} variant="scrollable" scrollButtons="auto">
        {tabs.map(({ label, value, to, icon }) => (
          <Tab
            key={value}
            {...a11yProps(prefixId, value)}
            wrapped
            label={label}
            value={value ?? false}
            to={to}
            state={linkState}
            component={Link}
            icon={icon}
            iconPosition="start"
            sx={{
              maxWidth: '250px',
              [breakpoints.down('md')]: {
                fontSize: '0.875rem',
                padding: '8px calc(0.5rem + 2px)',
              },
              [breakpoints.up('md')]: {
                flex: '1',
              },
            }}
          />
        ))}
      </MuiTabs>
    </Box>
  );
}
